import React from "react";

import Nav from "../../layout/Nav";
import Body from "../../layout/Body";
import Footer from "../../layout/Footer/Footer";

import PrivacyPolicy from "../../modules/privacyPolicy";

const PrivacyPolicyPage = () => {
  return (
    <>
      <Nav />
      <Body>
        <PrivacyPolicy />
      </Body>
      <Footer />
    </>
  );
};

export default PrivacyPolicyPage;
